// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"3093":"list","3180":"story"}[chunkId] || chunkId) + "-" + {"3093":"2826e41d7e62aa8ee6d0","3180":"a7e21c0e09bd06f3ac81","9635":"668ff762c86ddb42d1cd"}[chunkId] + ".css";
};